import { registerClass } from '../../SatCoreRegistry';

export default class GradebookStandardsService {
  // TODO placeholder
}

registerClass('GradebookStandardsService', GradebookStandardsService);
